import { Component } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap";
import { IMsgBoxEventArgs } from "../msgbox.interfaces";

@Component({
  selector: "msgbox-content",
  templateUrl: "./msgbox-content.component.html",
  styleUrls: ["./msgbox-content.component.css"]
})
export class MsgboxContent {
  title: string;
  options: any;
  message: string;
  callback: Function;

  constructor(public bsModalRef: BsModalRef) {}

  btnClick(model: any) {
    model.ladda = true;

    const args: IMsgBoxEventArgs = {
      cancel: true,
      result: model.result
    };

    if (this.callback) {
      this.callback(args);
    }

    if (args.cancel) {
      this.bsModalRef.hide();
    }
  }
}
